import { staticComponentValueConverter } from '../StaticComponentValues';
import { useSelector } from 'react-redux';

function Comments_1({ item }) {
  const customization = staticComponentValueConverter(item?.customization);

  const star = (
    <svg
      style={{ width: customization?.commentStarSize, height: customization?.commentStarSize }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.4446 5.9416C15.3776 5.72283 15.2484 5.53019 15.0739 5.38891C14.8995 5.24764 14.688 5.16434 14.4672 5.14993L10.4905 4.86521L9.01761 1.01104C8.93718 0.798821 8.7972 0.616529 8.61577 0.487766C8.43434 0.359002 8.21983 0.289695 8 0.288818C7.78017 0.289695 7.56566 0.359002 7.38423 0.487766C7.20281 0.616529 7.06282 0.798821 6.98239 1.01104L5.48277 4.88604L1.53285 5.14993C1.31226 5.16527 1.10118 5.24893 0.926928 5.39006C0.752672 5.5312 0.623253 5.72333 0.555413 5.9416C0.485747 6.16321 0.481677 6.40139 0.543727 6.62542C0.605776 6.84946 0.731101 7.04908 0.903541 7.19854L3.94297 9.86521L3.03917 13.5527C2.97664 13.8022 2.9879 14.0654 3.07147 14.3081C3.15505 14.5508 3.30708 14.7619 3.50781 14.9138C3.70265 15.0589 3.93478 15.1403 4.1745 15.1477C4.41422 15.1552 4.65062 15.0882 4.85346 14.9555L7.99331 12.893H8.0067L11.3876 15.1083C11.561 15.2252 11.7632 15.2878 11.97 15.2888C12.1389 15.2874 12.3052 15.2459 12.4562 15.1674C12.6072 15.089 12.7388 14.9756 12.841 14.8361C12.9431 14.6966 13.0131 14.5347 13.0455 14.3628C13.0778 14.1908 13.0718 14.0135 13.0278 13.8444L12.0704 9.80965L15.0965 7.19854C15.2689 7.04908 15.3942 6.84946 15.4563 6.62542C15.5183 6.40139 15.5143 6.16321 15.4446 5.9416Z"
        fill={customization?.commentStarColor}
      ></path>
    </svg>
  );
  return (
    <div className="flex flex-col gap-[10px] p-[10px]">
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <div
          style={{
            color: customization?.textColor,
            fontSize: customization?.textSize,
            fontWeight: customization?.textWeight,
            textAlign: customization?.textAlignment,
            fontStyle: customization?.textStyle,
          }}
        >
          {customization?.text}
        </div>
        <div>
          <svg width="20px" height="20px" viewBox="0 0 0.5 0.5" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0.25 0.35a0.025 0.025 0 0 1 -0.018 -0.007l-0.125 -0.125a0.025 0.025 0 1 1 0.035 -0.035L0.25 0.29l0.107 -0.107a0.025 0.025 0 1 1 0.035 0.035l-0.125 0.125A0.025 0.025 0 0 1 0.25 0.35"
              fill="#5C5F62"
            />
          </svg>
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ textAlign: 'center', marginRight: 15 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div
              style={{
                fontSize: customization?.raitingNumberTextSize,
                fontWeight: customization?.raitingNumberTextWeight,
                color: customization?.raitingNumberTextColor,
                fontStyle: customization?.raitingNumberTextStyle,
              }}
            >
              4.1
            </div>
            <div style={{ marginTop: -4 }}>
              {customization?.isShowStar === 'show' && (
                <svg
                  fill="#000000"
                  width={customization?.starSize}
                  height={customization?.starSize}
                  viewBox="0 0 0.84 0.84"
                  id="star"
                  data-name="Flat Color"
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon flat-color"
                >
                  <path
                    id="primary"
                    d="M0.77 0.343A0.035 0.035 0 0 0 0.741 0.319L0.542 0.291 0.451 0.123a0.035 0.035 0 0 0 -0.062 0L0.3 0.291 0.101 0.319a0.035 0.035 0 0 0 -0.029 0.025 0.035 0.035 0 0 0 0.01 0.035l0.144 0.13 -0.035 0.183a0.035 0.035 0 0 0 0.052 0.039l0.178 -0.088 0.179 0.088 0.015 0.004a0.035 0.035 0 0 0 0.035 -0.041L0.615 0.511 0.759 0.381A0.035 0.035 0 0 0 0.77 0.343"
                    fill={customization?.starColor}
                  />
                </svg>
              )}
            </div>
          </div>
          <div
            style={{
              color: customization?.totalRaitingTextColor,
              fontSize: customization?.totalRaitingTextSize,
              fontStyle: customization?.totalRaitingTextStyle,
              fontWeight: customization?.totalRaitingTextWeight,
            }}
          >
            246 ratings
          </div>
        </div>
        <div style={{ flex: 1, width: '100%' }}>
          {[5, 4, 3, 2, 1].map((star, index) => (
            <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
              <span
                style={{
                  color: customization?.horizontalLineTextColor,
                  fontSize: customization?.horizontalLineTextSize,
                  fontStyle: customization?.horizontalLineTextStyle,
                  fontWeight: customization?.horizontalLineTextWeight,
                }}
              >
                {star}
              </span>
              <div
                style={{
                  width: '100%',
                  background: customization?.horizontalLineBackgroundColor,
                  height: 8,
                  borderRadius: 4,
                  marginLeft: 5,
                  position: 'relative',
                }}
              >
                <div
                  style={{
                    background: customization?.horizontalLineColor,
                    height: '100%',
                    borderRadius: 4,
                    width: ['80%', '20%', '15%', '5%', '10%'][index],
                  }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="flex gap-[10px]">
        <div
          className="flex flex-col items-start gap-[5px] border border-1 border-[#E0E4E5] py-[20px] px-[20px]"
          style={{
            width: '93%',
            borderRadius: customization?.borderRadius,
          }}
        >
          <div
            style={{
              textAlign: customization?.commentTextAlignment,
              fontWeight: customization?.commentTextWeight,
              color: customization?.commentTextColor,
              fontSize: customization?.commentTextSize,
              fontStyle: customization?.commentTextStyle,
            }}
          >
            Gave it to my cousin and she love it as a jewelry box
          </div>
          {customization?.isShowCommentStar === 'show' && (
            <div className="flex gap-[2px]">
              <span>{star}</span>
              <span>{star}</span>
              <span>{star}</span>
              <span>{star}</span>
              <span>{star}</span>
            </div>
          )}
          <div
            style={{
              color: customization?.commenterAndDateTextColor,
              fontStyle: customization?.commenterAndDateTextStyle,
              fontWeight: customization?.commenterAndDateTextWeight,
            }}
          >
            Ebony · September 10, 2024
          </div>
        </div>
        <div
          className="flex flex-col items-start gap-[5px] border border-1 border-[#E0E4E5] py-[20px] "
          style={{
            borderRadius: customization?.borderRadius,
            borderRight: 'none',
            width: '7%',
          }}
        ></div>
      </div>
      <div
        style={{
          backgroundColor: customization?.buttonBackgroundColor,
          color: customization?.buttonTextColor,
          fontSize: customization?.buttonTextSize,
          fontWeight: customization?.buttonTextWeight,
          fontStyle: customization?.buttonTextStyle,
        }}
        className=" p-[5px] rounded-[10px]"
      >
        Tümünü Göster
      </div>
      <div
        style={{
          backgroundColor: customization?.buttonBackgroundColor,
          color: customization?.buttonTextColor,
          fontSize: customization?.buttonTextSize,
          fontWeight: customization?.buttonTextWeight,
          fontStyle: customization?.buttonTextStyle,
        }}
        className="flex justify-center items-center gap-[3px]  p-[5px] rounded-[10px]"
      >
        <svg
          width="20px"
          height="16px"
          viewBox="0 -0.045 0.54 0.54"
          id="meteor-icon-kit__regular-comment"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.113 0.045A0.068 0.068 0 0 0 0.045 0.113V0.405L0.127 0.338h0.301A0.068 0.068 0 0 0 0.495 0.27V0.113A0.068 0.068 0 0 0 0.427 0.045zm0.031 0.338L0.074 0.44A0.045 0.045 0 0 1 0 0.405V0.113A0.113 0.113 0 0 1 0.113 0h0.315A0.113 0.113 0 0 1 0.54 0.113V0.27a0.113 0.113 0 0 1 -0.113 0.113z"
            fill={customization?.buttonTextColor}
          />
        </svg>
        Yorum yap
      </div>
    </div>
  );
}

export default Comments_1;
